import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BnpOidcHelperLoginService {
  constructor() {
    console.log("Hello my first lib version 2 ");
  }
}
